import { WhatsappCode, GmailId } from "./WhatsappModal";

const IconBox = ({ name, imgURL, link, modal, id, title }) => {
    return (
        <a
            href={link}
            className="techStacks text-decoration-none"
            target="_blank" rel="noreferrer"
            data-bs-toggle={modal} data-bs-target={id}
        >
            <div className="gradient-color" title={title} >
                <img className="logo-size" src={imgURL} alt="icon" />
                <p className="text-center fs-5 pb-3">{name}</p>
            </div>
        </a>
    );
};

export const Contact = () => {
    return (
        <>
            <div id="contact" className="container top-margin">
                <h1 className="my-4">Contact Me</h1>
                <div className="gridFormat">

                    <IconBox
                        name={"LinkedIn"}
                        title={"linkedin.com/in/m-sehrawat"}
                        link={"https://www.linkedin.com/in/m-sehrawat/"}
                        imgURL={"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg"}
                    />

                    <IconBox
                        name={"GitHub"}
                        title={"github.com/m-sehrawat"}
                        link={"https://github.com/m-sehrawat"}
                        imgURL={"https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/github-512.png"}
                    />

                    <IconBox
                        name={"Gmail"}
                        title={"mohitsehrawat000@gmail.com"}
                        imgURL={"https://cdn-icons-png.flaticon.com/512/888/888853.png"}
                        modal={"modal"} id={"#gmail"}
                    />

                    {/* <IconBox
                        name={"Whatsapp"}
                        title={"Scan to connect on WhatsApp"}
                        imgURL={"./whatsapp-logo.png"}
                        modal={"modal"} id={"#whatsapp"}

                    /> */}
                </div>
                <WhatsappCode />
                <GmailId />
            </div>

            <div className="container tagLine mt-4">
                <p id="madeByMohit">Made with ❤️ by Mohit Sehrawat</p>
            </div>
        </>
    );
};

//